import React from 'react';
import {Link, Route, Redirect} from 'react-router-dom';
import {Table, Tag, Button, Spin, Input, Row, Col, Divider, Breadcrumb, Menu, Icon, Dropdown} from 'antd';
import monitorService from '../services/monitor.service';
import fileDownloadService from "../services/file.download.service";
import Toolbar from '../commons/Toolbar';
const {Search} = Input;

class AccessContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataTable: [],
            loading: true,
        }
    }

    componentDidMount = () => {
        monitorService.getAccess().then((access) => {
            console.log('User access: ', access);
            this.setState(() => {
                return {dataTable: access.rows, loading: false}
            })
        });
    };

    handleDownload = (event) => {
        let period = event.key;
        if (period) {
            fileDownloadService.download('/api/v1/monitor/logins/download/' + period, 'loginsLast' + period + '.csv');
        }
    };

    render() {
        const columns = [
            {
                title: 'Date',
                dataIndex: 'loginDate',
                key: 'loginDate',
                sorter: (a, b) => {
                    return a.loginDate.localeCompare(b.loginDate)
                },
            },
            {
                title: 'User Name',
                dataIndex: 'username',
                key: 'username',
                sorter: (a, b) => {
                    return a.username.localeCompare(b.username, 'en', {sensitivity: 'base', numeric: true,});
                    console.log(a.username, b.username)
                },
            },
            {
                title: 'IP Address',
                dataIndex: 'clientIP',
                key: 'clientIP',
                sorter: (a, b) => {
                    return a.clientIP.localeCompare(b.clientIP)
                },
            },
            {
                title: 'LogIn Status',
                dataIndex: 'loginStatus',
                key: 'loginStatus',
            },
            {
                title: 'LogOut Status',
                key: 'logoutStatus',
                dataIndex: 'logoutStatus',

            },
            {
                title: 'Logout Date',
                dataIndex: 'logoutDate',
                key: 'logoutDate',
            },

        ];


        const menu = (
            <Menu>
                <Menu.Item key="7d" onClick={this.handleDownload}>
                    <Icon type="download"/>
                    Last 7 days
                </Menu.Item>
                <Menu.Item key="30d" onClick={this.handleDownload}>
                    <Icon type="download"/>
                    Last 30 days
                </Menu.Item>
                <Menu.Item key="6m" onClick={this.handleDownload}>
                    <Icon type="download"/>
                    Last 6 months
                </Menu.Item>
                <Menu.Item key="1y" onClick={this.handleDownload}>
                    <Icon type="download"/>
                    Last 1 year
                </Menu.Item>
            </Menu>
        )

        const pagination = {
            total: this.state.count,
            pageSize: 14,
            pageSizeOptions: ['14'],
        }
        const toolBarItems = [
            {
                title: 'Download',
                icon: 'download',
                type: 'dropdown-button',
                menu: menu,
                trigger: ['click']
            }
        ]

        return (
            <div>
                <Row>
                    <Breadcrumb style={{margin: '16px 0'}}>
                        <Breadcrumb.Item>Access</Breadcrumb.Item>
                    </Breadcrumb>
                    <Divider style={{background: '#8080802e', margin: '0px 0px 17px 0px'}}/>
                </Row>
                <Row>
                    <Col span={12}>
                        <Row type="flex" justify="start">
                            <Search
                                onSearch={value => {
                                    this.setState(
                                        {
                                            searchString: value,
                                        },
                                    )
                                }}
                                style={{width: 330}}
                            />
                        </Row>
                    </Col>
                    <Col span={12}>
                        <Row type="flex" justify="end">
                            <Toolbar items={toolBarItems}/>
                        </Row>
                    </Col>
                    <Divider style={{background: 'transparent', margin: '5px 0px 12px 0px'}}/>
                </Row>
                <div  style={{boxShadow: '0 1px 20px 0 rgba(69, 90, 100, .08)'}}>
                        <Spin spinning={this.state.loading} delay={500}>
                            <Table
                                dataSource={this.state.dataTable}
                                columns={columns}
                                pagination={pagination}
                            />
                        </Spin>
                </div>
            </div>
        )
    }
}

export default AccessContainer